import type { ReactNode } from 'react';

import { usePermissions } from '@/contexts/auth';

import { FeatureUnavailable } from './FeatureUnavailable';

interface OptoScaleAdminRouteProps {
    children?: ReactNode;
    /** Where the unavailable state's link leads, normally the location dashboard. */
    unavailableLinkTo: string;
}

/**
 * A page only OptoScale admins may open, whatever its feature flag says: anyone else gets the
 * same "not available for your account" state a refused flag shows.
 */
export function OptoScaleAdminRoute({ children, unavailableLinkTo }: OptoScaleAdminRouteProps) {
    const { isOptoScaleAdmin } = usePermissions();
    if (!isOptoScaleAdmin)
        return <FeatureUnavailable linkTo={unavailableLinkTo} reason="disabled" />;
    return <>{children}</>;
}
